@if (contentlet()) { @if (currentPageURI$ | async; as URI) { @if (URI=== contentlet().urlMap) {
<custom-dot-cms-blog-detail />
} @else {
<custom-dot-cms-blog-post [contentlet]="contentlet()" />
} } }
